import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 662 662"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M331 0a331 331 0 1 1 0 662 331 331 0 0 1 0-662m148.5 109 .6.9a187 187 0 1 1-297.6-.9 267 267 0 1 0 297 0"
    }, null, -1)
  ]));
}
const LogoAPI = { render };
export {
  LogoAPI as default,
  render
};
//# sourceMappingURL=LogoAPI.svg.js.map
